module.exports = __webpack_public_path__ + "static/img/xeogen-renewal.3845278.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/xeogen-renewal.jpg
// module id = 87IT
// module chunks = 0